const freeCreditsPaths = {
  SEARCH_FREE_CREDITS_REPORT: "search/report",
  SEARCH_FREE_CREDITS_REPORT_EXPORT: "search/report/export",
};

export default freeCreditsPaths;
